<div class="wrapper">
  <app-bubble [color]="color" [value]="value"></app-bubble>
  <div class="pointer" [style.border-top]="'10px solid ' + color"></div>
</div>
